export const CHUNKS_LENGTH = 12;
